export default {
  groups: `/v1/groups/groups`,
  group: (id: string) => `/v1/groups/groups/${id}`,
  users: `/v1/groups/users`,
  user: (id: string) => `/v1/groups/users/${id}`
};
